var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAIconBacteria18 = function SvgAIconBacteria18(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    stroke: "currentColor"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.74665 14.0433C12.7592 14.0433 15.2013 11.6011 15.2013 8.5886C15.2013 5.57608 12.7592 3.13394 9.74665 3.13394C6.73412 3.13394 4.29199 5.57608 4.29199 8.5886C4.29199 11.6011 6.73412 14.0433 9.74665 14.0433Z",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.7832 3.13395V1",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.1367 3.64823L12.6697 2.55778",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0371 5.09433L17.0002 2.74415",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M15.1162 7.19128L16.2416 6.92169",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M15.1641 10.2624L16.4095 10.5092",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1748 12.4006L16.7858 14.42",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3379 13.9192L13.6673 17.0003",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M7.43048 3.64823L6.13672 1",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M5.53157 5.09433L4.29199 4.11129",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M4.45321 7.19129L3.22168 6.8968",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M4.4039 9.53507L1 10.2101",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M5.39346 12.4006L3.6377 13.6824",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M7.23257 13.9192L6.21191 15.8092",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M9.7832 14.531V15.5979",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.1474 9.53578C12.0572 9.53578 12.7948 8.81923 12.7948 7.93532C12.7948 7.05141 12.0572 6.33486 11.1474 6.33486C10.2376 6.33486 9.5 7.05141 9.5 7.93532C9.5 8.81923 10.2376 9.53578 11.1474 9.53578Z",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M7.31348 9.53578C7.46512 9.53578 7.58804 9.65521 7.58804 9.80253",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M7.04297 9.80253C7.04277 9.73173 7.07164 9.66377 7.12317 9.6137C7.17471 9.56364 7.24466 9.5356 7.31754 9.53578",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M7.31363 10.0693C7.24075 10.0695 7.1708 10.0414 7.11927 9.99135C7.06773 9.94128 7.03887 9.87333 7.03906 9.80252",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M7.58804 9.80252C7.58804 9.94984 7.46512 10.0693 7.31348 10.0693",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export { SvgAIconBacteria18 as ReactComponent };
export default "data:image/svg+xml;base64,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";